module.exports = __webpack_public_path__ + "static/media/column_chart_icon.caa9cebd.svg";